




import Vue from 'vue';
import ContentList from '@/components/content/content-list.component.vue';

export default Vue.extend({
  components: {
    'content-list': ContentList,
  },
});
